import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-produktgruppe-list-view',
  imports: [],
  templateUrl: './produktgruppe.list-view.html',
  styleUrls: ['./produktgruppe.list-view.css'],
})
export class ProduktgruppeListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
